// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

// Service
import TabelaContatosService from "./TabelaContatosService";

export default {
  props: {
    listagemContatos: {
      type: Array,
      default: () => [
        // {
        //   "cdUnimed": Number,
        //   "email": String,
        //   "id": Number,
        //   "nome": String,
        //   "notificacaoAtiva": Boolean,
        //   "telefone": String
        // }
      ]
    },
    loadingContatos: {
      type: Boolean,
      default: false
    },
    valoresSwitchProp: {
      type: Array,
      default: () => []
    }
  },
  mixins: [TabelaMixin, TabelaContatosService],
  data() {
    return {
      valoresSwitchData: [],
      cabecalho: [
        {
          texto: "Nome"
        },
        {
          texto: "Email"
        },
        {
          texto: "Telefone",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "100px"
          }
        },
        {
          texto: "Notificação"
        },
        {
          texto: ""
        }
      ]
    };
  },
  methods: {
    /**
     * Método que pega a atual array de valores dos switchs na tabela
     * @param {Array<Boolean>} valoresSwitch
     */
    inputArraySwitch(valoresSwitch) {
      this.valoresSwitchData = valoresSwitch.map(e => e);
    },
    /**
     * Método que pega o index e o valor atual do switch
     * @param {{ index: Number, value: Boolean }} objetoSwitch
     */
    inputSwitch(objetoSwitch) {
      this.$emit("editar-notificacao", objetoSwitch);
    },
    /**
     * Método que é chamado na hora de escolher uma ação da tabela
     * @param {{ id: Number, acao: Number }} objetoAcao
     */
    escolherAcao(objetoAcao) {
      const { acao, id } = objetoAcao;
      const idAtual = this.rows[id].naoMostrar.id;

      switch (acao) {
        case 0:
          this.$emit("editar-contato", idAtual);
          break;
        case 1:
          this.$emit("historico", idAtual);
          break;
        case 2:
          this.$emit("excluir-contato", idAtual);
          break;
      }
    }
  },
  computed: {
    /**
     * Retorna true se o status do arquivo for diferente de PROCESSANDO e a quantidade de erros for maior que 0
     * @return {Boolean}
     */
    mostrarBotaoAdicionar() {
      return this.rows.length < 10;
    }
  },
  watch: {
    listagemContatos: {
      deep: true,
      handler() {
        this.rows = this.listagemContatos.map(e => e);
      }
    },
    valoresSwitchProp: {
      deep: true,
      handler() {
        this.valoresSwitchData = this.valoresSwitchProp.map(e => e);
      }
    }
  }
};
